import { Modal } from "reactstrap";
import { Col } from "reactstrap";
import React, { useState } from "react";
import { newAdmin } from "../../services/api/userService.ts";

const NewAdminModalOld = ({ onNewCompany }) => {
  const [modal_standard, setmodal_standard] = useState(false);

  function tog_standard() {
    setmodal_standard(!modal_standard);
  }
  const sendData = async () => {
    const newAdministrateur = {
      cie_ID: document.getElementById("floatingSiretInput").value,
      cie_NAME: document.getElementById("floatingNameInput").value,
      cie_ADDRESS: document.getElementById("floatingAddressInput").value,
      cie_PHONE: document.getElementById("floatingPhoneInput").value,
      cie_EMAIL: document.getElementById("floatingEmailInput").value,
    };

    try {
      const response = await newAdmin(newAdministrateur);
      console.log(response);
      onNewCompany();
    } catch (error) {
      console.error(error);
    }
    /* const adminComp = {
        user_NAME: document.getElementById("floatingAdminNameInput").value,
        user_SURNAME: document.getElementById("floatingAdminNameInput").value,
        user_PHONE: document.getElementById("floatingAdminNameInput").value,
        user_EMAIL: document.getElementById("floatingAdminNameInput").value,
    };*/
  };
  return (
    <React.Fragment>
      <button
        type="button"
        onClick={() => {
          tog_standard();
        }}
        className="btn btn-primary btn-sm "
        data-toggle="modal"
        data-target="#myModal"
      >
        + Admin
      </button>
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Nouvelle admin
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h6>Information de société</h6>
          <Col md={6}>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="floatingSiretInput"
                placeholder="Enter Your Siret"
              />
              <label htmlFor="floatingSiretInput">Number Siret</label>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="floatingNameInput"
                placeholder="Enter Your Name"
              />
              <label htmlFor="floatingNameInput">Company Name</label>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="floatingAddressInput"
                placeholder="Enter Your Address"
              />
              <label htmlFor="floatingAddressInput">Address</label>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-floating mb-3">
              <input
                type="tel"
                className="form-control"
                id="floatingPhoneInput"
                placeholder="Enter Your Phone number"
              />
              <label htmlFor="floatingPhoneInput">Phone</label>
            </div>
          </Col>
          <Col md={6}>
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                id="floatingEmailInput"
                placeholder="Enter Your Email"
              />
              <label htmlFor="floatingEmailInput">Email</label>
            </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_standard();
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary "
            onClick={() => {
              sendData();
              setmodal_standard(false);
            }}
          >
            Save changes
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default NewAdminModalOld;
